import type React from 'react';
import { useEffect } from 'react';
import { useThrottledCallback } from 'use-debounce';

const useScrollLoadMore = ({
  ref,
  onLoadMore,
  nearBottom = 300, // 距底部多少像素时触发
}: {
  ref: React.RefObject<HTMLElement>;
  onLoadMore: () => void;
  nearBottom?: number;
}) => {
  const isTouchBottom = useThrottledCallback(
    () => {
      const element = ref.current;
      if (element) {
        const maxScroll = element.scrollHeight - element.clientHeight; // 最大滚动距离
        const scrollTopHeight = element.scrollTop; // 当前滚动位置
        if (scrollTopHeight + nearBottom >= maxScroll) {
          onLoadMore();
        }
      }
    },
    200,
    { leading: true, trailing: false }
  );

  useEffect(() => {
    const element = ref.current;
    if (element) {
      element.addEventListener('scroll', isTouchBottom);
    }

    return () => {
      element?.removeEventListener('scroll', isTouchBottom);
    };
  }, [nearBottom, ref.current, onLoadMore]);
};

// 滚动容器若一开始没有滚动条，则自动触发一次 load
export const useCompensationLoadMore = ({
  ref,
  onLoadMore,
}: {
  ref: React.RefObject<HTMLElement>;
  onLoadMore: () => void;
  nearBottom?: number;
}) => {
  useEffect(() => {
    const element = ref.current;
    if (element && element.scrollHeight <= element.clientHeight) {
      onLoadMore();
    }
  }, [ref]);
};

export { useScrollLoadMore };
